import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistica',
  templateUrl: './statistica.component.html',
  styleUrls: ['./statistica.component.scss']
})
export class StatisticaComponent implements OnInit {

  @Input() icon: string;
  @Input() iconType: string;
  @Input() data: any;

  constructor() { }

  ngOnInit(): void {
  }

}
